import { Alert } from "react-bootstrap";
import type { AlertProps } from "react-bootstrap";
import { BsInfoCircle, BsCheckCircle, BsExclamationCircle, BsExclamationTriangle} from "react-icons/bs";

export const IconAlert = (props: AlertProps) => {
  return (
    <Alert {...props}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <span style={{ marginTop: -1 }}>{getIcon(props.variant)}</span>
        <div>{props.children}</div>
      </div>
    </Alert>
  );
}

const getIcon = (variant?: string) => {
  switch (variant) {
    case 'info':
      return <BsInfoCircle size={24}/>;
    case 'success':
      return <BsCheckCircle size={24}/>;
    case 'danger':
      return <BsExclamationCircle size={24}/>;
    case 'warning':
      return <BsExclamationTriangle size={24}/>;
    default:
      return null;
  }
};

export default IconAlert;
